import React, {Component} from "react";
import {API} from "aws-amplify";
import TableExpandable from "./TableExpandable";

export default class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            items: [],
            users: []
        };
    }

    async componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            const items = await this.items();
            const users = await this.users();
            this.setState({items: this.handleItems(items, users)});
        } catch (e) {
            alert(e);
        }

        this.setState({isLoading: false});
    }

    items() {
        return API.get("admin", "/items/unhandled");
    }

    users() {
        return API.get("admin", "/users/scan");
    }

    handleItems(items, users) {
        // console.log(items);
        // console.log(users);
        const userMap = {};
        users.forEach(user => {
            userMap[user.userId] = user
        });
        items.forEach(item => {
            item.user = userMap[item.userId];
        });
        return items;
    }

    removeItem(item) {

    }

    removeItemFromList(item) {
        setTimeout(() => {
            const newItems = [];
            this.state.items.forEach(i => {
                if (i.itemId !== item.itemId) {
                    newItems.push(i);
                }
            });
            this.setState({items: newItems});
        }, 1000);
    }

    renderItems() {
        return (
            <div className="items">
                <h1>Nye kjøp</h1>
                <div>
                    {this.state.isLoading && <i className="fas fa-spinner fa-spin"/>}
                    {!this.state.isLoading && <TableExpandable data={this.state.items} showHandledButton
                                                               title={"Ingen nye kjøp registrert."}
                                                               removeItemFromList={(item) => this.removeItemFromList(item)}/>}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="Home content shadow">
                {this.renderItems()}
            </div>
        );
    }
}